import { getSearchPath } from "src/consts/urlPaths";

export const DEDICATION_TEAM_PARAM = "dedicationTeam";
export const DEDICATION_KEY_PARAM = "dedicationKey";
export const DEDICATION_PIT_PARAM = "dedicationPit";

const KEYS = ["fullyHere", "partHere", "split", "overCapacity"] as const;

export type DedicationKey = (typeof KEYS)[number];

const isDedicationKey = (value: string): value is DedicationKey =>
  (KEYS as readonly string[]).includes(value);

/** People page for one dedication line on this team. */
export const dedicationPeoplePath = (
  teamId: string,
  key: DedicationKey,
  pit?: string
): string => {
  const path = getSearchPath("people", null, false);
  const params = new URLSearchParams();
  params.set(DEDICATION_TEAM_PARAM, teamId);
  params.set(DEDICATION_KEY_PARAM, key);
  if (pit) {
    params.set(DEDICATION_PIT_PARAM, pit);
  }
  return `${path}?${params.toString()}`;
};

export const parseDedicationPeopleSearch = (
  search: string
): { teamId: string; key: DedicationKey; pit?: string } | null => {
  const params = new URLSearchParams(search);
  const teamId = params.get(DEDICATION_TEAM_PARAM)?.trim() ?? "";
  const key = params.get(DEDICATION_KEY_PARAM)?.trim() ?? "";
  if (!teamId || !isDedicationKey(key)) {
    return null;
  }
  const pit = params.get(DEDICATION_PIT_PARAM)?.trim() || undefined;
  return pit ? { teamId, key, pit } : { teamId, key };
};

/** Query string to keep when other search filters are stripped. */
export const dedicationPeopleSearch = (search: string): string => {
  const parsed = parseDedicationPeopleSearch(search);
  if (!parsed) {
    return "";
  }
  const params = new URLSearchParams();
  params.set(DEDICATION_TEAM_PARAM, parsed.teamId);
  params.set(DEDICATION_KEY_PARAM, parsed.key);
  if (parsed.pit) {
    params.set(DEDICATION_PIT_PARAM, parsed.pit);
  }
  return `?${params.toString()}`;
};
